import React, { useEffect, useState } from "react";
import YukXatiHeader from "../../../Components/YukXati/YukXatiHeader";
import { Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";

export default function Total({ setOpen, open }) {
  // let [open, setOpen] = useState(false);
  let [loading, setLoading] = useState(false);
  let [data, setData] = useState(null);
  let navigate = useNavigate();
  const messageApi = useMessage();

  let getSolds = async () => {
    try {
      setLoading(true);

      let { data } = await axiosInstance.get("/api/unofficial/total");
      if (data.success) {
        setData(data.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSolds();
  }, [open]);

  const products = [
    { name: "Product A", count: 10, size: "Large", date: "2025-01-15" },
    { name: "Product B", count: 5, size: "Medium", date: "2025-01-10" },
    { name: "Product C", count: 20, size: "Small", date: "2025-01-08" },
  ];

  if (!data) return null;

  return (
    <Modal
      style={{ top: "10px" }}
      width="100vw"
      title="Kirim / Chiqim"
      open={open}
      loading={loading}
      onOk={() => {
        setOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setOpen(false);
      }}
      footer={
        [
          // <Button
          //   key="back"
          //   onClick={() => {
          //     // handleAddDriver();
          //     // setAddNewDriverModal(false);
          //     // console.log(addNewDriverData);
          //   }}
          //   // style={{ backgroundColor: "#f5222d", color: "#fff" }}
          // >
          //   Saqlash
          // </Button>,
        ]
      }
    >
      <div className="overflow-auto">
        <div className="container mx-auto p-4">
          <h2 className="text-xl font-bold mb-4">Sotilgan</h2>
          <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
            <thead>
              <tr className="bg-gray-100">
                <th className="text-left px-4 py-2 border-b">Nomi</th>
                <th className="text-left px-4 py-2 border-b">Qoldiq</th>
                <th className="text-left px-4 py-2 border-b">Kunlik</th>
                <th className="text-left px-4 py-2 border-b">Haftalik</th>
                <th className="text-left px-4 py-2 border-b">Oylik</th>
                <th className="text-left px-4 py-2 border-b">Jami</th>
              </tr>
            </thead>
            <tbody>
              {data.map((product, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  } hover:bg-gray-100`}
                >
                  <td className="px-4 py-2 border-b">{product.name}</td>
                  <td className="px-4 py-2 border-b">{product.remains}</td>
                  <td className="px-4 py-2 border-b">
                    {product.details.sell.daily}
                  </td>
                  <td className="px-4 py-2 border-b">
                    {product.details.sell.weekly}
                  </td>
                  <td className="px-4 py-2 border-b">
                    {product.details.sell.monthly}
                  </td>
                  <td className="px-4 py-2 border-b">
                    {product.details.sell.total}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="container mx-auto p-4">
          <h2 className="text-xl font-bold mb-4">Kirim</h2>
          <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
            <thead>
              <tr className="bg-gray-100">
                <th className="text-left px-4 py-2 border-b">Nomi</th>
                <th className="text-left px-4 py-2 border-b">Qoldiq</th>
                <th className="text-left px-4 py-2 border-b">Kunlik</th>
                <th className="text-left px-4 py-2 border-b">Haftalik</th>
                <th className="text-left px-4 py-2 border-b">Oylik</th>
                <th className="text-left px-4 py-2 border-b">Jami</th>
              </tr>
            </thead>
            <tbody>
              {data.map((product, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? "bg-gray-50" : "bg-white"
                  } hover:bg-gray-100`}
                >
                  <td className="px-4 py-2 border-b">{product.name}</td>
                  <td className="px-4 py-2 border-b">{product.remains}</td>
                  <td className="px-4 py-2 border-b">
                    {product.details.buy.daily}
                  </td>
                  <td className="px-4 py-2 border-b">
                    {product.details.buy.weekly}
                  </td>
                  <td className="px-4 py-2 border-b">
                    {product.details.buy.monthly}
                  </td>
                  <td className="px-4 py-2 border-b">
                    {product.details.buy.total}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Modal>
  );
}
